// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DisplayNamedFragmentDoc, NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveChangeEventLineItemsMutationVariables = Types.Exact<{
  input: Types.SaveChangeEventLineItemsInput;
}>;


export type SaveChangeEventLineItemsMutation = { __typename?: 'Mutation', saveChangeEventLineItems: { __typename?: 'SaveChangeEventLineItemsResult', changeEventLineItems: Array<{ __typename?: 'ChangeEventLineItem', costType: Types.CostType, totalPriceInCents: number, totalCostInCents: number, quantity?: number | null | undefined, type: Types.ChangeEventLineItemType, id: string, name: string, location: { __typename?: 'Location', id: string, name: string }, costConfidenceDetail: { __typename?: 'CostConfidenceDetail', code: Types.CostConfidence, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, id: string, name: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, isPublished: boolean, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus, name: string }, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, selectedOption?: { __typename?: 'HomeownerSelectionOption', unitPriceInCents?: number | null | undefined, unitCostInCents?: number | null | undefined, id: string, name: string, product: { __typename?: 'Product', id: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }> } } | null | undefined } | null | undefined, item: { __typename?: 'Item', fullCode: string, id: string, name: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, displayName: string } | null | undefined }, projectItem: { __typename?: 'ProjectItem', id: string, isSelection: boolean, projectStage: { __typename?: 'ProjectStage', id: string, canEditProjectScope: { __typename?: 'PotentialOperation2', allowed: boolean } } } }> } };

export type EditChangeEventLineItemFragment = { __typename?: 'ChangeEventLineItem', costType: Types.CostType, totalPriceInCents: number, totalCostInCents: number, quantity?: number | null | undefined, type: Types.ChangeEventLineItemType, id: string, name: string, location: { __typename?: 'Location', id: string, name: string }, costConfidenceDetail: { __typename?: 'CostConfidenceDetail', code: Types.CostConfidence, name: string }, unitOfMeasure: { __typename?: 'UnitOfMeasure', useQuantity: boolean, id: string, name: string }, homeownerSelection?: { __typename?: 'HomeownerSelection', id: string, isPublished: boolean, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus, name: string }, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, selectedOption?: { __typename?: 'HomeownerSelectionOption', unitPriceInCents?: number | null | undefined, unitCostInCents?: number | null | undefined, id: string, name: string, product: { __typename?: 'Product', id: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }> } } | null | undefined } | null | undefined, item: { __typename?: 'Item', fullCode: string, id: string, name: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, displayName: string } | null | undefined }, projectItem: { __typename?: 'ProjectItem', id: string, isSelection: boolean, projectStage: { __typename?: 'ProjectStage', id: string, canEditProjectScope: { __typename?: 'PotentialOperation2', allowed: boolean } } } };

export type ChangeEventLineItemUnitOfMeasureFragment = { __typename?: 'UnitOfMeasure', useQuantity: boolean, id: string, name: string };

export type ChangeEventLineItemSelectionFragment = { __typename?: 'HomeownerSelection', id: string, isPublished: boolean, status: { __typename?: 'HomeownerSelectionStatusDetail', code: Types.HomeownerSelectionStatus, name: string }, canPublish: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, selectedOption?: { __typename?: 'HomeownerSelectionOption', unitPriceInCents?: number | null | undefined, unitCostInCents?: number | null | undefined, id: string, name: string, product: { __typename?: 'Product', id: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }> } } | null | undefined };

export type ChangeEventLineItemSelectionOptionFragment = { __typename?: 'HomeownerSelectionOption', unitPriceInCents?: number | null | undefined, unitCostInCents?: number | null | undefined, id: string, name: string, product: { __typename?: 'Product', id: string, images: Array<{ __typename?: 'Asset', id: string, downloadUrl: string }> } };

export type ChangeEventLineItemItemFragment = { __typename?: 'Item', fullCode: string, id: string, name: string, costCode: { __typename?: 'CostCode', id: string, displayName: string }, tradeCategory?: { __typename?: 'TradeCategory', id: string, displayName: string } | null | undefined };

export const ChangeEventLineItemUnitOfMeasureFragmentDoc = gql`
    fragment ChangeEventLineItemUnitOfMeasure on UnitOfMeasure {
  ...Named
  useQuantity
}
    ${NamedFragmentDoc}`;
export const ChangeEventLineItemSelectionOptionFragmentDoc = gql`
    fragment ChangeEventLineItemSelectionOption on HomeownerSelectionOption {
  ...Named
  unitPriceInCents
  unitCostInCents
  product {
    id
    images {
      id
      downloadUrl
    }
  }
}
    ${NamedFragmentDoc}`;
export const ChangeEventLineItemSelectionFragmentDoc = gql`
    fragment ChangeEventLineItemSelection on HomeownerSelection {
  id
  isPublished
  status {
    code
    name
  }
  canPublish {
    allowed
    disabledReasons {
      message
    }
  }
  selectedOption {
    ...ChangeEventLineItemSelectionOption
  }
}
    ${ChangeEventLineItemSelectionOptionFragmentDoc}`;
export const ChangeEventLineItemItemFragmentDoc = gql`
    fragment ChangeEventLineItemItem on Item {
  ...Named
  fullCode
  costCode {
    id
    displayName
  }
  tradeCategory {
    id
    displayName
  }
}
    ${NamedFragmentDoc}`;
export const EditChangeEventLineItemFragmentDoc = gql`
    fragment EditChangeEventLineItem on ChangeEventLineItem {
  ...Named
  costType
  totalPriceInCents
  totalCostInCents
  quantity
  type
  location {
    ...Named
  }
  costConfidenceDetail {
    code
    name
  }
  unitOfMeasure {
    ...ChangeEventLineItemUnitOfMeasure
  }
  homeownerSelection {
    ...ChangeEventLineItemSelection
  }
  item {
    ...ChangeEventLineItemItem
  }
  projectItem {
    id
    isSelection
    projectStage {
      id
      canEditProjectScope {
        allowed
      }
    }
  }
}
    ${NamedFragmentDoc}
${ChangeEventLineItemUnitOfMeasureFragmentDoc}
${ChangeEventLineItemSelectionFragmentDoc}
${ChangeEventLineItemItemFragmentDoc}`;
export const SaveChangeEventLineItemsDocument = gql`
    mutation SaveChangeEventLineItems($input: SaveChangeEventLineItemsInput!) {
  saveChangeEventLineItems(input: $input) {
    changeEventLineItems {
      ...EditChangeEventLineItem
    }
  }
}
    ${EditChangeEventLineItemFragmentDoc}`;
export type SaveChangeEventLineItemsMutationFn = Apollo.MutationFunction<SaveChangeEventLineItemsMutation, SaveChangeEventLineItemsMutationVariables>;

/**
 * __useSaveChangeEventLineItemsMutation__
 *
 * To run a mutation, you first call `useSaveChangeEventLineItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveChangeEventLineItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveChangeEventLineItemsMutation, { data, loading, error }] = useSaveChangeEventLineItemsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveChangeEventLineItemsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveChangeEventLineItemsMutation, SaveChangeEventLineItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveChangeEventLineItemsMutation, SaveChangeEventLineItemsMutationVariables>(SaveChangeEventLineItemsDocument, options);
      }
export type SaveChangeEventLineItemsMutationHookResult = ReturnType<typeof useSaveChangeEventLineItemsMutation>;
export type SaveChangeEventLineItemsMutationResult = Apollo.MutationResult<SaveChangeEventLineItemsMutation>;
export type SaveChangeEventLineItemsMutationOptions = Apollo.BaseMutationOptions<SaveChangeEventLineItemsMutation, SaveChangeEventLineItemsMutationVariables>;